import { SelectProps } from '../interface/interface';
import ReactSelect from 'react-select';
import {
  components,
  ValueContainerProps,
  DropdownIndicatorProps,
} from 'react-select';
import { DownCaretIcon } from '../assets/svgImages';

const ValueContainer = ({ children, ...props }: ValueContainerProps<any>) => {
  let [values, input] = children as any;

  if (Array.isArray(values)) {
    const plural = values.length === 1 ? '' : 's';
    values = `${values.length} item${plural} selected`;
  }

  return (
    <components.ValueContainer {...props}>
      {values}
      {input}
    </components.ValueContainer>
  );
};

const DropdownIndicator = (props: DropdownIndicatorProps<true>) => {
  return (
    <components.DropdownIndicator {...props}>
      <DownCaretIcon className='w-4' />
    </components.DropdownIndicator>
  );
};

export function Select(props: SelectProps) {
  return (
    <>
      {props.defaultSelected !== undefined && (
        <ReactSelect
          classNames={{
            control: (state) =>
              state.isFocused
                ? 'border-grey-400 border text-sm'
                : 'border-grey-400 border text-sm',
          }}
          options={props.options.map((o: { id: number|string; name: string }) => ({
            label: o.name,
            value: o.id,
          }))}
          isLoading={props.loading}
          isMulti
          placeholder={props.placeholder}
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          value={props.defaultSelected.map((e) => ({
            label: e.name,
            value: e.id,
          }))}
          onChange={props.onChange}
          components={
            {
              ValueContainer,
              DropdownIndicator,
              IndicatorSeparator: () => null,
            } as any
          }
        />
      )}
    </>
  );
}
